import * as Sentry from '@sentry/react'
import { googleAnalytics } from '~/constants/config'
import {
  AnalyticsEventFromNamespace,
  AnalyticsNamespace,
} from '~/types/Analytics'

import {
  ExtensionInstance,
  Analytics as IAnalytics,
  Pbx,
  SessionUser,
} from '@mangovoice/types'

export const initializeAnalytics = (
  user: SessionUser | undefined,
  userExtension: ExtensionInstance | undefined,
  pbx: Pbx | undefined,
) => {
  if (user && user.id !== undefined && userExtension) {
    Sentry.setUser({
      id: user.id.toString(),
      username: userExtension.name,
    })
  }

  window.gtag('config', googleAnalytics.PRODUCTION, {
    user_id: user?.id ?? 'Unknown User ID',
  })

  if (pbx) {
    Sentry.setContext('pbx', {
      pbx_id: pbx.id,
      pbx_uuid: pbx.uuid,
      pbx_name: pbx.name,
    })
  }

  window.gtag('set', 'user_properties', {
    ext_name: userExtension?.name ?? 'Unknown Extension Name',
    pbx_uuid: pbx?.uuid ?? 'Unknown PBX UUID',
    pbx_id: pbx?.id ?? 'Unknown PBX ID',
    pbx_name: pbx?.name ?? 'Unknown PBX Name',
  })
}

export class Analytics<TNamespace extends AnalyticsNamespace>
  implements IAnalytics
{
  private _nameSpace: TNamespace
  constructor(nameSpace: TNamespace) {
    this._nameSpace = nameSpace
  }

  public track = (
    name: AnalyticsEventFromNamespace<TNamespace> | string,
    data?: Record<string, unknown>,
  ) => {
    window.gtag('event', `${this._nameSpace}_${name}`, data)
  }
}
